import { IProduct } from '@mybestbrands/types';
import { useEffect, useState } from 'react';
import { isDirectClickoutRetailerExcluded } from '@/app/ui/components/list/listitem/helpers/isDirectClickoutRetailerExcluded';
import { getMbbAttributionObject } from '@/app/helpers/hooks/mbb_attribution';

function isPaidTraffic(url: string) {
  return (
    url?.includes('gclid') ||
    url?.includes('gad_source') ||
    url?.includes('utm_source') ||
    url?.includes('utm_medium') ||
    url?.includes('utm_campaign')
  );
}

function isSearchEngineReferral(document: Document) {
  const referrer = document.referrer.toLowerCase();
  return referrer.includes('google') || referrer.includes('bing') || referrer.includes('yahoo');
}

export const useIsSeoClickOutEnabled = (item: IProduct) => {
  const isToggleEnabled = process.env.NEXT_PUBLIC_FT_DIRECT_CLICKOUT === 'true';
  const [isSETraffic, setIsSETraffic] = useState(false);
  const isExcludedRetailer = isDirectClickoutRetailerExcluded(item.retailerId);

  useEffect(() => {
    setIsSETraffic(!isPaidTraffic(window.location.search) && isSearchEngineReferral(document));
  }, []);

  return !isExcludedRetailer && isSETraffic && isToggleEnabled;
};

export const useIsPaidTraffic = () => {
  const isToggleEnabled = process.env.NEXT_PUBLIC_FT_DIRECT_CLICKOUT === 'true';
  const [isPaid, setIsPaidTraffic] = useState(false);
  const mbbAttributionObject = getMbbAttributionObject();

  useEffect(() => {
    const isPaidFromMbb = isPaidTraffic(mbbAttributionObject.initial_qs);
    const isPaidBoolean = isSearchEngineReferral(document) && (isPaidTraffic(window.location.search) || isPaidFromMbb);
    setIsPaidTraffic(isPaidBoolean);
  }, []);
  return isPaid && isToggleEnabled;
};
